const trackMateriel = {
  materialCode: 'MaterialCode',
  productCode: 'ProductCode',
  productName: 'ProductName',
  status: 'Status',
  enabled: 'Enabled',
  msg: {}
};
export default trackMateriel;



// WEBPACK FOOTER //
// ./src/page/md/trackMateriel/lang/trackMateriel.en.js